import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AgentBetPage = ({ agent }) => {
  const [form, setForm] = useState({ customer_number: '', amount: '', lucky_number: '' });
  const [message, setMessage] = useState('');

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setMessage('');
    if (isNaN(Number(form.amount))) {
      setMessage('Amount must be a number');
      return;
    }
    try {
      const res = await axios.post(`${API_BASE_URL}/bets`, {
        agent_number: agent.number,
        customer_number: form.customer_number,
        amount: form.amount,
        lucky_number: form.lucky_number
      });
      setMessage('Bet placed successfully! New balance: ' + res.data.newBalance);
      setForm({ customer_number: '', amount: '', lucky_number: '' });
    } catch (err) {
      setMessage(err.response?.data?.error || 'Failed to place bet');
    }
  };

  return (
    <div className="max-w-md mx-auto mt-12 bg-white p-8 rounded shadow">
      <div className="mb-4 text-green-700 font-semibold text-center">
        Logged in as: {agent.number}
      </div>
      <h2 className="text-xl font-bold mb-4">Place Bet</h2>
      <form onSubmit={handleSubmit}>
        <input name="customer_number" type="text" placeholder="Customer Number" className="border px-3 py-2 w-full mb-3" value={form.customer_number} onChange={handleChange} required />
        <input
          name="amount"
          type="number"
          placeholder="Amount"
          className="border px-3 py-2 w-full mb-3"
          value={form.amount}
          onChange={e => setForm({ ...form, amount: e.target.value.replace(/\D/g, '') })} // <-- Only allow digits
          required
        />
        <input name="lucky_number" type="text" placeholder="Lucky Number" className="border px-3 py-2 w-full mb-3" value={form.lucky_number} onChange={handleChange} required />
        <button className="bg-green-600 text-white px-4 py-2 rounded w-full font-bold" type="submit">Place Bet</button>
      </form>
      {message && <div className="mt-3 text-blue-700">{message}</div>}
    </div>
  );
};

export default AgentBetPage;